import React, { useState } from "react";
import { ReactComponent as Settings } from "assets/img/icons/settings.svg";
import classNames from "classnames";
import { useGlobalContext } from "store/contexts/globalContext";
import { Modal } from "react-responsive-modal";
import { ReactComponent as Lock } from "assets/img/icons/lockSvg.svg";
import { ReactComponent as CloseIcon } from "assets/img/icons/cancel.svg";
import { ReactComponent as DeleteIcon } from "assets/img/icons/cross.svg";
import ChangePassword from "components/ChangePassword";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowCircleLeft } from "@fortawesome/free-solid-svg-icons";
import DeleteAccount from "components/DeleteAccount";

const styles = {
  icon: {
    width: "20px",
    height: "20px",
    fill: "#2a323d",
  },
  settingOptions: {
    display: "flex",
    alignItems: "center",
    gap: "5px",
  },
  settingsName: {
    fontSize: "15px",
    fontWeight: 400,
  },
  contentSetting: {
    display: "flex",
    flexDirection: "column",
    gap: "15px",
  },
  backIcon: {
    width: "20px",
    height: "20px",
  },
};

export default () => {
  const classes = styles;
  const { microsoftConfigureTab } = useGlobalContext();
  const [openSettings, setSettings] = useState(false);
  const [settingsOption] = useState([
    { id: 1, name: "Change Password", icon: <Lock style={classes.icon} /> },
    {
      id: 2,
      name: "Delete Account",
      icon: <DeleteIcon style={classes.icon} />,
    },
  ]);
  const [selectedContent, setSelectedContent] = useState(null);
  const [SettingPage] = useState({
    1: <ChangePassword />,
    2: <DeleteAccount />,
  });
  const [heading, setHeading] = useState("Settings");

  const handleClose = () => {
    setSelectedContent(null);
    setHeading("Settings");
    setSettings(false);
  };

  const handleSetting = (setting) => {
    setSelectedContent(setting.id);
    setHeading(setting.name);
  };

  const goBack = () => {
    setSelectedContent(null);
    setHeading("Settings");
  };

  return (
    <>
      <div
        onClick={() => setSettings(true)}
        className={classNames({
          settingsButtonStyle: !microsoftConfigureTab ? true : false,
          settingsButtonMicrosoftStyle: microsoftConfigureTab ? true : false,
        })}
      >
        <Settings className="settingsAvatarStyle" />
        <div className="userDesktop">Settings</div>
      </div>
      <Modal
        classNames={{
          modalContainer: "modalContainer",
          modal: "settingsModal",
        }}
        open={openSettings}
        showCloseIcon={false}
        onClose={handleClose}
      >
        <div>
          <div className="modalHeaderSettings">
            {selectedContent && (
              <div className="modalBack" onClick={goBack}>
                <FontAwesomeIcon
                  style={classes.backIcon}
                  icon={faArrowCircleLeft}
                />
              </div>
            )}
            <div className="modalHeading">{heading}</div>
            <div className="modalCloseIcon">
              <CloseIcon className="closeIcon" onClick={handleClose} />
            </div>
          </div>
          <div className="modalContentSettings" style={classes.contentSetting}>
            {!selectedContent &&
              settingsOption.map((setting) => (
                <div
                  key={setting.id}
                  className="settingOption"
                  onClick={() => handleSetting(setting)}
                >
                  <div style={classes.settingOptions}>
                    {setting.icon}
                    <span style={classes.settingsName}>{setting.name}</span>
                  </div>
                </div>
              ))}
            {selectedContent && SettingPage[selectedContent]}
          </div>
        </div>
      </Modal>
    </>
  );
};
